import { InjectionToken } from '@angular/core';
import { Pipeline } from '../entities/pipeline.model';
import { CategorizationItem, Step } from '../entities/step.model';

export const PIPELINE_SERVICE = new InjectionToken<PipelineRepository>('PIPELINE_SERVICE');
export interface PipelineRepository {
  findForSample(sampleId: string): Promise<Pipeline[]>;
  findStepsForSample(sampleId: string): Promise<{ steps: Step[]; categories: Record<string, CategorizationItem> }>;
}
